import React from 'react';

/**
 * User-facing panel when an embedded service cannot be reached.
 * Avoids browser jargon ("refused to connect", etc.).
 */
export default function EmbedUnavailablePanel({
  serviceName,
  src,
  onRetry,
  className = '',
  style,
}) {
  const label = serviceName || 'This service';

  return (
    <div
      role="alert"
      className={className}
      style={{
        position: 'absolute',
        inset: 0,
        zIndex: 20,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f9fafb',
        padding: 24,
        ...style,
      }}
    >
      <div style={{ textAlign: 'center', maxWidth: 420 }}>
        <div
          style={{
            width: 48,
            height: 48,
            margin: '0 auto 16px',
            borderRadius: 12,
            background: '#eff6ff',
            color: '#2563eb',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 22,
            fontWeight: 700,
          }}
          aria-hidden
        >
          !
        </div>
        <div style={{ fontSize: 16, fontWeight: 600, color: '#111827', marginBottom: 8 }}>
          {label} is temporarily unavailable
        </div>
        <div style={{ fontSize: 14, color: '#6b7280', lineHeight: 1.5, marginBottom: 20 }}>
          We couldn&apos;t load this module right now. Please try again in a moment.
          If the problem continues, contact your administrator.
        </div>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          {typeof onRetry === 'function' && (
            <button
              type="button"
              onClick={onRetry}
              style={{
                border: 'none',
                borderRadius: 8,
                padding: '10px 16px',
                background: '#2563eb',
                color: '#ffffff',
                fontSize: 14,
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              Try again
            </button>
          )}
          {src ? (
            <a
              href={src}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                border: '1px solid #d1d5db',
                borderRadius: 8,
                padding: '10px 16px',
                background: '#ffffff',
                color: '#374151',
                fontSize: 14,
                fontWeight: 500,
                textDecoration: 'none',
              }}
            >
              Open in new tab
            </a>
          ) : null}
        </div>
      </div>
    </div>
  );
}
